export default __webpack_public_path__ + "static/media/search-loader.3b50e15d.gif";